import 'css-chunksrc/client/scenes/chatConversationRemoval/styles.scss';export default {
  "header": "_header_1lyaa_1",
  "message": "_message_1lyaa_5",
  "name": "_name_1lyaa_10",
  "main": "_main_1lyaa_14",
  "buttons": "_buttons_1lyaa_21"
};